var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddPlusGreenRoundedWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.35077 0 0.5 7.8501 0.5 17.5C0.5 27.1499 8.35077 35 18 35C27.6492 35 35.5 27.1499 35.5 17.5C35.5 7.8501 27.6492 0 18 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4111 16.9986L19.5112 11.264C19.5204 10.7361 19.0999 10.3007 18.5721 10.2916C18.0442 10.2824 17.6089 10.7028 17.5996 11.2307L17.4996 16.9654L11.7648 16.8652C11.2369 16.856 10.8016 17.2764 10.7924 17.8043C10.7832 18.3321 11.2036 18.7675 11.7315 18.7768L17.4661 18.8768L17.366 24.6115C17.3568 25.1394 17.7773 25.5748 18.3051 25.584C18.833 25.5932 19.2683 25.1728 19.2776 24.6449L19.3777 18.9102L25.1124 19.0103C25.6402 19.0195 26.0756 18.5991 26.0848 18.0712C26.094 17.5433 25.6736 17.108 25.1457 17.0987L19.4111 16.9986Z",
    fill: "#7BCB45"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7504_15017",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 17,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4111 16.9986L19.5112 11.264C19.5204 10.7361 19.0999 10.3007 18.5721 10.2916C18.0442 10.2824 17.6089 10.7028 17.5996 11.2307L17.4996 16.9654L11.7648 16.8652C11.2369 16.856 10.8016 17.2764 10.7924 17.8043C10.7832 18.3321 11.2036 18.7675 11.7315 18.7768L17.4661 18.8768L17.366 24.6115C17.3568 25.1394 17.7773 25.5748 18.3051 25.584C18.833 25.5932 19.2683 25.1728 19.2776 24.6449L19.3777 18.9102L25.1124 19.0103C25.6402 19.0195 26.0756 18.5991 26.0848 18.0712C26.094 17.5433 25.6736 17.108 25.1457 17.0987L19.4111 16.9986Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7504_15017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.875 -4.375H40.75V40.25H-3.875V-4.375Z",
    fill: "#7BCB45"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddPlusGreenRoundedWhite);
export default __webpack_public_path__ + "static/media/icAddPlusGreenRoundedWhite.e2d8722da023ec230d4550bbcc40e144.svg";
export { ForwardRef as ReactComponent };